import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { SecurityService } from './security.service';

@Injectable()
export class TokenHttpInterceptor implements HttpInterceptor {
    constructor(private injector: Injector, public securityService: SecurityService) { }
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const securityService = this.injector.get(SecurityService);
        if (request.url.indexOf(`/api/`) > -1) {
            let token = securityService.getAccessToken();
            if (token) {
                let authHeader = `Bearer ${token}`;
                request = request.clone({
                    setHeaders: {
                        Authorization: `${authHeader}`
                    }
                });
                return next.handle(request)
            } else {
                return next.handle(request)
            }
        } else {
            return next.handle(request);
        }
    }
}
